import TableCell from "@material-ui/core/TableCell";
import React from "react";

export const ContentCell =(props:{key?:any;align?:'right'|'left';children:any})=>{
    let alignment = props.align || 'left';
    return (
        <TableCell valign="middle" align={alignment} style={{
            fontSize:16
        }}>
            {props.children}
        </TableCell>
    );
}